// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { getAllocationsAsAtDates } from '../../../../utils/disclaimers/comparison';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const CreditQualityDisclaimer = ({ items, showItemNames, locale }: Props) => {
  const fixedIncomeItems = items.filter(
    i =>
      !!i.disclaimers &&
      !i.disclaimers[DISCLAIMER_KEYS.FUND_CREDIT_QUALITY_NOT_APPLICABLE] &&
      !i.disclaimers[DISCLAIMER_KEYS.PORTFOLIO_CREDIT_QUALITY_NOT_APPLICABLE],
  );

  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.CreditQuality', locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      itemDates={getAllocationsAsAtDates(fixedIncomeItems, locale)}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
};

export default CreditQualityDisclaimer;
